"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderAriaLiveAnnouncer_unstable", {
    enumerable: true,
    get: function() {
        return renderAriaLiveAnnouncer_unstable;
    }
});
const _jsxruntime = require("@fluentui/react-jsx-runtime/jsx-runtime");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const renderAriaLiveAnnouncer_unstable = (state, contextValues)=>{
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_reactsharedcontexts.AnnounceProvider, {
        value: contextValues.announce,
        children: state.children
    });
};
